import { render } from "./SingleSaleForEight.vue?vue&type=template&id=17503189&scoped=true"
import script from "./SingleSaleForEight.vue?vue&type=script&lang=js"
export * from "./SingleSaleForEight.vue?vue&type=script&lang=js"

import "./SingleSaleForEight.vue?vue&type=style&index=0&id=17503189&scoped=true&lang=css"

import exportComponent from "C:\\Users\\מפתח רוסמן\\Desktop\\Projects\\RosmanNext\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17503189"]])

export default __exports__